import React, { useState, useEffect } from 'react';
import ExitIntentPopup from './ExitIntentPopup';
import { useExitIntent } from '@/hooks/useExitIntent';

const ExitIntentWrapper: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const { isExiting, reset } = useExitIntent({
    threshold: 10,
    delay: 5000, // 5 seconds on page before enabling
    sensitivity: 20
  });

  useEffect(() => {
    // Check if popup has been shown in this session
    const hasShownInSession = sessionStorage.getItem('exitIntentShown');
    if (hasShownInSession) {
      setHasShown(true);
      return;
    }

    if (isExiting && !hasShown && !showPopup) {
      setShowPopup(true);
      setHasShown(true);
      sessionStorage.setItem('exitIntentShown', 'true');
    }
  }, [isExiting, hasShown, showPopup]);

  const handleClose = () => {
    setShowPopup(false);
    reset();
  };

  if (!showPopup || hasShown) {
    return null;
  }

  return <ExitIntentPopup onClose={handleClose} variant="both" />;
};

export default ExitIntentWrapper;